import { EventEmitter, Injectable } from '@angular/core';
import { CheckoutContactForm, CheckoutValidator, ValidationErrorKeys, ValidationErrors } from '@checkout/const';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const initialFormValues: CheckoutContactForm = {
  phone: '',
  addPhone: '',
  email: '',

  // эти поля не отображаем на странице
  comment: '',
  callMe: false,
};

@Injectable({
  providedIn: 'root',
})
export class CheckoutContactFormService implements CheckoutValidator {
  formValues$ = new BehaviorSubject<CheckoutContactForm>(initialFormValues);
  isSubmitting$ = new BehaviorSubject<boolean>(false);
  isSubmitted$ = new BehaviorSubject<boolean>(false);
  isValid$ = new BehaviorSubject<boolean>(false);

  submitEvent = new EventEmitter();

  reset(): void {
    this.isSubmitting$.next(false);
    this.isSubmitted$.next(false);
    this.isValid$.next(false);
    this.formValues$.next(initialFormValues);
  }

  validate(): Observable<ValidationErrors> {
    return this.isValid$.pipe(
      map((isValid) => {
        const errors: ValidationErrors = {};

        if (!isValid) {
          errors[ValidationErrorKeys.CONTACTS_REQUIRED] = 'Необходимо заполнить контакты';
        }

        return errors;
      }),
    );
  }

  submit(): void {
    this.submitEvent.emit();
  }

  markLoading(): void {
    this.isSubmitting$.next(true);
  }

  markSuccess(): void {
    this.isSubmitting$.next(false);
    this.isSubmitted$.next(true);
  }

  // нужно в адаптере
  get queryData(): { [id: string]: string } {
    const data: PlainObject = {};
    const values: PlainObject = this.formValues$.getValue();

    for (const i in values) {
      if (!Object.prototype.hasOwnProperty.call(values, i)) {
        continue;
      }

      data[i] = values[i] === null ? '' : values[i].toString();
    }

    return data;
  }
}
